// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8842cf4e","455":"fbfbeb6b","977":"8c35837e"}[chunkId] + ".chunk.js";
};